import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  url = appUrls.tickets;
  constructor(private http: HttpClient) { }

  getTicketByQuoteId(quoteId) {
    let url = this.url.getTicketsByQuoteIds  + quoteId;
    return this.http.get(url);
  }
  createNewTicket(ticket) {
    return this.http.post(this.url.createNewTicket, ticket);
  }

}
